import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
export function CTAFinal() {
  const {
    ref,
    isVisible
  } = useScrollAnimation({
    threshold: 0.3
  });
  return <section id="contacto" className="bg-petrol-gradient py-10 md:py-14" data-id="element-52">
      <div className="max-w-4xl mx-auto px-6 md:px-8 text-center" data-id="element-53">
        <div ref={ref} className={`scroll-animate ${isVisible ? 'is-visible' : ''}`} data-id="element-54">
          <h2 className="font-heading text-4xl md:text-5xl text-white font-light leading-tight mb-5" data-id="element-55">
            Despejamos incertidumbre.
            <br className="hidden md:block" data-id="element-56" /> Diseñamos dirección.
          </h2>

          <p className="font-body text-lg md:text-xl text-white/80 mb-8 max-w-2xl mx-auto" data-id="element-57">
            Conversemos sobre su contexto regulatorio, político o institucional.
          </p>

          <div className="flex items-center justify-center mb-6" data-id="element-58">
            <a href="http://wa.me/5491122438278" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto bg-white text-petrol-dark font-body text-sm uppercase tracking-wider px-8 py-4 rounded hover:scale-105 transition-transform duration-300 shadow-lg text-center inline-block" data-id="element-59">
              Enviar consulta
            </a>
          </div>

          <p className="font-body text-sm text-white/50 tracking-wide" data-id="element-60">
            Respuesta confidencial. Enfoque ejecutivo.
          </p>
        </div>
      </div>
    </section>;
}